export const LANDING = '/';
export const ITEM = '/item';
export const CART = '/cart';
export const WISHLIST = '/wishlist';
export const NOT_FOUND = '/404';
